import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaArrdDe.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        canLinkType(map, node, type) {
            return (/^(DE)$/.test(type))
        },

        canMountType(map, node, type) {
            return /^(CAT)$/.test(type)
        },

        menuItemsInsertCommon(map, node) {
            return [
                {type: 'CAT'},
            ]
        },

        menuItemsInsertProduct(map, node) {
            return [
                {type: 'DE'},
                {type: 'DE_1'},
            ]
        },
    })
}
